import { http } from "@/libs/esg-acsp-core-vue-lib/utils/Http";

/**
 * 获取月结卡
 * @param {*} data
 */
export const queryMonthCardInfo = (data) =>
  http.post("/portal-web-app/app/user/queryMonthCardInfo", data);

/**
 * 获取用户手机号
 * @returns
 */
export const getUserMobile = () => {
  return http.request({
    method: "get",
    url: "/route/api/info",
    isToLogin: false,
  });
};
/**
 * 退出登录
 * @param {*} data
 */
export const userLogout = () => http.delete("/route/api/loginout");

/**
 * 获取验证码
 * @param {mobile} data
 * @returns
 */
export const verifyMobile = (data) => {
  return http.request({
    method: "post",
    url: "/route/api/verify",
    data,
    showError: false,
  });
};

/**
 * 获取验证码
 * @param {mobile} data
 * @returns
 */
export const userLogin = (url, data) => {
  return http.request({
    method: "post",
    url: `/route/api/login?redirect_uri=${url}`,
    data,
    showError: false,
  });
};

/**
 * B端-账户写入
 * @param {jwt} data
 * @returns
 */
export const jwtWrite = (data) => {
  return http.request({
    method: "post",
    url: "/route/api/jwt",
    data,
    showError: false,
  });
};
